<template>
	<headers></headers>
	<RouterView />
	<footers></footers>
</template>

<script>
	import headers from './components/header.vue'
	import footers from './components/footer.vue'
	export default {
		name: 'App',
		components: {
			headers,
			footers
		}
	}
</script>

<style lang="less">
	:root{
		--swiper-navigation-color:#eee;
	}
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		//text-align: center;
		//color: #2c3e50
	}

	.clear {
		clear: both;
	}

	.warp {
		width: 100%;
		margin: auto;
		padding: 0;
	}

	a,
	a:hover {
		text-decoration: none;
		cursor: pointer;
	}

	.text-gray {
		color: #666;
	}

	.hide {
		display: none;
	}

	.flex {
		display: flex;
		flex-wrap: nowrap;
	}

	.flex-1 {
		flex: 1;
	}

	.flex-bettwen {
		display: flex;
		justify-content: space-between;
	}

	.flex-around {
		display: flex;
		justify-content:space-around;
	}
	.flex-warp {
		flex-wrap: wrap;
	}
	.v-top {
		align-items: top;
	}

	.border-b {
		border-bottom: 1px solid #eee;
	}

	.h-center {
		justify-content: center;

	}

	.h-right {
		justify-content: right;

	}

	.content-warp {
		width: 94%;
		max-width: 1460px;
		min-width: 0px;
		height: auto;
		max-height: none;
		min-height: 0px;
		margin-top: 0px;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 0px;
		padding-top: 0px;
		padding-left: 0px;
		padding-right: 0px;
		padding-bottom: 0px;
	}

	.container {
		max-width: 1400px;
		margin: auto;
	}

	.footer-warp {
		width: 94%;
		max-width: 1580px;
		min-width: 0px;
		height: auto;
		max-height: none;
		min-height: 0px;
		margin-top: 0px;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 0px;
		padding-top: 0px;
		padding-left: 0px;
		padding-right: 0px;
		padding-bottom: 0px;

	}

	img {
		border: 0;
		text-decoration: none;
	}

	li,
	ul,
	dl,
	dt,
	dd,
	ol,
	ul {
		list-style: none;
		text-decoration: none;
	}

	.v-center {
		align-items: center;
	}

	.line-32 {
		line-height: 32px;
	}

	.line-2em {
		line-height: 2em;
	}

	.padding-tb {
		padding: 20px 0;
	}


	.tabs {
		display: flex;
		margin: 0;
		padding: 0;

		.item {
			display: block;
			list-style: none;
			height: 64px;
			line-height: 64px;
			padding: 0px 30px;
			cursor: pointer;
			color: #333;

		}

		.active {
			color: #fff;
			background-color: #c30d23;
		}

		.item:hover {
			color: #fff;
			background-color: #c30d23;
		}
	}

	.bg-gray {
		width: 100%;
		min-width: 1200px;
		height: 64px;

		background-color: rgba(242, 242, 242, 1);

	}

	body {
		font-size: 16px;
		margin: 0;
		padding: 0;
	}
</style>
